// extracted by mini-css-extract-plugin
export var primitiveLabel = "_um-0";